import { render } from "./ClassroomProgramDataTable.vue?vue&type=template&id=21ec6308"
import script from "./ClassroomProgramDataTable.vue?vue&type=script&lang=js"
export * from "./ClassroomProgramDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__